import axios from 'axios';

async function request(context, method, path, data, params) {
	try {
		const response = await axios({ method, url: `${context.rootGetters['settings/getUrl']}${path}`, data, params, headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } });
		return response.data;
	} catch (error) {
		if (error.response && error.response.status === 401) context.commit('profile/setLogout', {}, { root: true });
		throw error;
	}
}

export default {
	namespaced: true,
	actions: {
		list: (context, params) => request(context, 'get', 'audit', undefined, params),
		detail: (context, id) => request(context, 'get', `audit/${id}`),
		profiles: context => request(context, 'get', 'profile/options'),
		options: context => request(context, 'get', 'audit/options'),
		trash: (context, { section, params }) => request(context, 'get', `trash/${section}`, undefined, params),
		trashDetail: (context, { section, id, profileId }) => request(context, 'get', `trash/${section}/${id}`, undefined, { profileId }),
		restore: (context, { section, ids, profileId }) => request(context, 'post', `trash/${section}/restore`, { ids }, { profileId }),
	},
};
